import { VHeaders } from '@/models/pagedlistmodel';

export function getStoreHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('users.UserStoreGridHeaders.StoreName') as string,
      align: 'left',
      value: 'storeName',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'users.UserStoreGridHeaders.overrideAction'
      ) as string,
      value: 'accountOverrides',
      align: 'left',
      sortable: true,
      fieldType: 'html',
      filters: [
        (val: any) => {
          if (val && val !== 'N/A' && val.length) {
            return `<span> ${val} </span>`;
          } else {
            return ' ';
          }
        },
      ],
    },
    {
      text: vm.$parent.$t('users.UserStoreGridHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
